import HighlightButton from "./HighlightButton";
import HighlightPanel from "./HighLightPanel";

export default {
    button: HighlightButton,
    panel: HighlightPanel,
    name: "highlight",
};
